import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import usePatientPayScheduleCriteria from "./hooks/usePatientPayScheduleCriteria";  
  
const PatientPayScheduleCriteria = () => {  
  const PatientPayScheduleCriteriaData = usePatientPayScheduleCriteria();  
  
  return (  
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={PatientPayScheduleCriteriaData.leftButtons} align="left" />   
      <div className="header-section">  
        <h1>  
          {PatientPayScheduleCriteriaData.screen_title} -{" "}  
          <span className="heading-cod">{PatientPayScheduleCriteriaData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={PatientPayScheduleCriteriaData.formFields}  
        dropdownValues={PatientPayScheduleCriteriaData.dropdownValues}  
        paramsData={PatientPayScheduleCriteriaData.paramsData}  
        updataParamData={PatientPayScheduleCriteriaData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={PatientPayScheduleCriteriaData.ctaButtons} />  
      <DisplayTable  
        data={PatientPayScheduleCriteriaData.data}  
        parmKey={PatientPayScheduleCriteriaData.parmKey}  
        menuOptions={PatientPayScheduleCriteriaData.menuOptions}  
        tableHeaders={PatientPayScheduleCriteriaData.columnDef}  
        setRowData={PatientPayScheduleCriteriaData.setRowData}  
        selectedPriceSchedules={PatientPayScheduleCriteriaData.selectedRows}  
        setSelectedPriceSchedules={PatientPayScheduleCriteriaData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={PatientPayScheduleCriteriaData.first}  
          rows={PatientPayScheduleCriteriaData.rows}  
          totalRecords={PatientPayScheduleCriteriaData.totalRecords}  
          currentPage={PatientPayScheduleCriteriaData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={PatientPayScheduleCriteriaData.onPageChange}  
        />  
      </div>  
      {PatientPayScheduleCriteriaData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={PatientPayScheduleCriteriaData.isConfirmationModalOpen}  
          onRequestClose={PatientPayScheduleCriteriaData.closeConfirmationModal}  
          onBack={PatientPayScheduleCriteriaData.closeConfirmationModal}  
          onSave={PatientPayScheduleCriteriaData.deletePatientPayScheduleCriteria}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={PatientPayScheduleCriteriaData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default PatientPayScheduleCriteria;  
